import { route } from 'ziggy';
import { Ziggy } from './ziggy';
import Lang from './translations';

let gr = (name, params) => {
    return String(route(name, params, false, Ziggy));
};

export default {
    // Don't add the 'home' route here, since we dont want the page title to show up on the homepage.
    'guest.login': () => {
        return [
            {name:Lang.get('breadcrumbs.home'), route:gr('home')},
            {name:Lang.get('breadcrumbs.login')},
        ]
    },
    'guest.register': () => {
        return [
            {name:Lang.get('breadcrumbs.home'), route:gr('home')},
            {name:Lang.get('breadcrumbs.login'), route:gr('guest.login')},
            {name:Lang.get('breadcrumbs.register')},
        ]
    },
    'guest.password.request': () => {
        return [
            {name:Lang.get('breadcrumbs.home'), route:gr('home')},
            {name:Lang.get('breadcrumbs.login'), route:gr('guest.login')},
            {name:Lang.get('breadcrumbs.password_request')},
        ]
    },
    'guest.password.reset': () => {
        return [
            {name:Lang.get('breadcrumbs.home'), route:gr('home')},
            {name:Lang.get('breadcrumbs.login'), route:gr('guest.login')},
            {name:Lang.get('breadcrumbs.password_reset')},
        ]
    },
    /*
     |
     | Content
     |
     */
    'content.index': (prop) => {
        if (!prop.props.content) {
            return [];
        }

        if (prop.props.content.data.slug && prop.props.content.data.slug.startsWith('blogs/')) {
            return [
                {name:Lang.get('breadcrumbs.home'), route:gr('home')},
                {name:Lang.get('menu.blogs'), route:gr('content.index', {any: Lang.get('menu.slugs.blogs')})},
                {name:prop.props.content.data.name},
            ]
        }

        return [
            {name:Lang.get('breadcrumbs.home'), route:gr('home')},
            {name:prop.props.content.data.name},
        ]
    },
    /*
     |
     | Cart
     |
     */
    'cart.index': () => {
        return [
            {name:Lang.get('breadcrumbs.home'), route:gr('home')},
            {name:Lang.get('breadcrumbs.cart')},
        ]
    },
    /*
     |
     | Checkout
     |
     */
    'auth.checkout.index': () => {
        return [
            {name:Lang.get('breadcrumbs.home'), route:gr('home')},
            {name:Lang.get('breadcrumbs.cart'), route:gr('cart.index')},
            {name:Lang.get('breadcrumbs.checkout')},
        ]
    },
    /*
     |
     | Categories
     |
     */
    'categories.index': () => {
        return [
            {name:Lang.get('breadcrumbs.home'), route:gr('home')},
            {name:Lang.get('breadcrumbs.categories')},
        ]
    },
    'categories.item': (prop) => {
        return [
            {name:Lang.get('breadcrumbs.home'), route:gr('home')},
            {name:Lang.get('breadcrumbs.categories'), route:gr('categories.index')},
            {name:prop.props.category.data.name},
        ]
    },
    'categories.custom.item': (prop) => {
        return [
            {name:Lang.get('breadcrumbs.home'), route:gr('home')},
            {name:Lang.get('breadcrumbs.categories'), route:gr('categories.index')},
            {name:prop.props.category.data.name},
        ]
    },
    /*
     |
     | Category
     |
     */
    'category.new': () => {
        return [
            {name:Lang.get('breadcrumbs.home'), route:gr('home')},
            {name:Lang.get('breadcrumbs.new')},
        ]
    },
    /*
     |
     | Bestsellers
     |
     */
    'bestsellers.index': () => {
        return [
            {name:Lang.get('breadcrumbs.home'), route:gr('home')},
            {name:Lang.get('breadcrumbs.bestsellers')},
        ]
    },
    /*
     |
     | Products
     |
     */
    'products.index': () => {
        return [
            {name:Lang.get('breadcrumbs.home'), route:gr('home')},
            {name:Lang.get('breadcrumbs.all_products')},
        ]
    },
    'products.brand-products': (prop) => {
        return [
            {name:Lang.get('breadcrumbs.home'), route:gr('home')},
            {name:Lang.get('breadcrumbs.all_products'), route:gr('products.index')},
            {name:prop.props.brand.data.name},
        ]
    },
    'products.item': (prop) => {
        return [
            {name:Lang.get('breadcrumbs.home'), route:gr('home')},
            {name:Lang.get('breadcrumbs.all_products'), route:gr('products.index')},
            {name:prop.props.product.data.brand.name, route:gr('products.brand-products', {brand_slug: prop.props.product.data.brand.slug})},
            {name:prop.props.product.data.name},
        ]
    },
    /*
     |
     | Orders
     |
     */
    'auth.orders.show': () => {
        return [
            {name:Lang.get('breadcrumbs.home'), route:gr('home')},
            {name:Lang.get('breadcrumbs.order')},
        ]
    },
    /*
     |
     | My Account
     |
     */
    'auth.myaccount.index': () => {
        return [
            {name:Lang.get('breadcrumbs.home'), route:gr('home')},
            {name:Lang.get('breadcrumbs.myaccount')},
        ]
    },
    /*
     | Addresses
     */
    'auth.myaccount.addresses.index': () => {
        return [
            {name:Lang.get('breadcrumbs.home'), route:gr('home')},
            {name:Lang.get('breadcrumbs.myaccount'), route:gr('auth.myaccount.index')},
            {name:Lang.get('breadcrumbs.addresses')},
        ]
    },
    'auth.myaccount.addresses.create': () => {
        return [
            {name:Lang.get('breadcrumbs.home'), route:gr('home')},
            {name:Lang.get('breadcrumbs.myaccount'), route:gr('auth.myaccount.index')},
            {name:Lang.get('breadcrumbs.addresses'), route:gr('auth.myaccount.addresses.index')},
            {name:Lang.get('breadcrumbs.create_address')},
        ]
    },
    'auth.myaccount.addresses.edit': () => {
        return [
            {name:Lang.get('breadcrumbs.home'), route:gr('home')},
            {name:Lang.get('breadcrumbs.myaccount'), route:gr('auth.myaccount.index')},
            {name:Lang.get('breadcrumbs.addresses'), route:gr('auth.myaccount.addresses.index')},
            {name:Lang.get('breadcrumbs.edit_address')},
        ]
    },
    /*
     | My orders
     */
    'auth.myaccount.orders.index': () => {
        return [
            {name:Lang.get('breadcrumbs.home'), route:gr('home')},
            {name:Lang.get('breadcrumbs.myaccount'), route:gr('auth.myaccount.index')},
            {name:Lang.get('breadcrumbs.orders')},
        ]
    },
    'auth.myaccount.orders.show': () => {
        return [
            {name:Lang.get('breadcrumbs.home'), route:gr('home')},
            {name:Lang.get('breadcrumbs.myaccount'), route:gr('auth.myaccount.index')},
            {name:Lang.get('breadcrumbs.orders'), route:gr('auth.myaccount.orders.index')},
            {name:Lang.get('breadcrumbs.show_order')},
        ]
    },
    /*
     | Invoices
     */
    'auth.myaccount.invoices.index': () => {
        return [
            {name:Lang.get('breadcrumbs.home'), route:gr('home')},
            {name:Lang.get('breadcrumbs.myaccount'), route:gr('auth.myaccount.index')},
            {name:Lang.get('breadcrumbs.invoices')},
        ]
    },
    /*
     | My profile
     */
    'auth.myaccount.details.index': () => {
        return [
            {name:Lang.get('breadcrumbs.home'), route:gr('home')},
            {name:Lang.get('breadcrumbs.myaccount'), route:gr('auth.myaccount.index')},
            {name:Lang.get('breadcrumbs.details')},
        ]
    },
    /*
     | Brands
     */
    'brands.index': () => {
        return [
            {name:Lang.get('breadcrumbs.home'), route:gr('home')},
            {name:Lang.get('breadcrumbs.brands')},
        ]
    },
    'brands.item': (prop) => {
        return [
            {name:Lang.get('breadcrumbs.home'), route:gr('home')},
            {name:Lang.get('breadcrumbs.brands'), route:gr('brands.index')},
            {name:prop.props.brand.data.name},
        ]
    },
}
